import React from 'react';
import { Search, PenTool, Code2, Rocket } from 'lucide-react';
import SectionHeading from './ui/SectionHeading';
import { RevealGroup, RevealItem } from './ui/Reveal';

const steps = [
    {
        icon: Search,
        title: 'Discovery & Audit',
        description: 'We map your workflows to find the bottlenecks and the highest-ROI automation opportunities.',
        duration: 'Week 1',
    },
    {
        icon: PenTool,
        title: 'Design & Blueprint',
        description: 'We architect the ideal system and align on scope, tools, and success metrics before building.',
        duration: 'Week 1–2',
    },
    {
        icon: Code2,
        title: 'Build & Integrate',
        description: 'Our engineers build, connect, and rigorously test the automation against real-world data.',
        duration: 'Week 2–4',
    },
    {
        icon: Rocket,
        title: 'Launch & Optimize',
        description: 'We deploy, train your team, and monitor performance — refining as your business evolves.',
        duration: 'Ongoing',
    },
];

const Process: React.FC = () => {
    return (
        <section id="process" className="relative py-24 md:py-32 bg-navy-800/40 border-y border-white/[0.05]">
            <div className="container-x">
                <SectionHeading
                    eyebrow="How we work"
                    title={<>From chaos to clarity in <span className="text-gradient">four steps</span></>}
                    subtitle="A proven, transparent process that gets you from first call to a fully-running automation in weeks, not months."
                />

                <RevealGroup className="mt-16 relative grid md:grid-cols-4 gap-8">
                    {/* connecting line */}
                    <div className="hidden md:block absolute top-8 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-brand-cyan/0 via-brand-cyan/40 to-brand-cyan/0" />

                    {steps.map((step, i) => (
                        <RevealItem key={step.title} className="relative text-center group">
                            <div className="relative z-10 w-16 h-16 mx-auto rounded-2xl bg-navy-900 border border-white/[0.1] grid place-items-center text-brand-cyan mb-6 shadow-card group-hover:border-brand-cyan/60 group-hover:shadow-glow-cyan transition-all duration-300">
                                <step.icon className="w-6 h-6" strokeWidth={1.75} />
                                <span className="absolute -top-2.5 -right-2.5 w-7 h-7 rounded-full bg-gradient-to-br from-brand-cyan to-brand-blue text-navy-900 text-xs font-bold grid place-items-center ring-4 ring-navy-800">
                                    {i + 1}
                                </span>
                            </div>
                            <span className="text-xs font-mono text-brand-cyan/80 uppercase tracking-wider">{step.duration}</span>
                            <h3 className="mt-2 font-display text-lg font-bold text-white">{step.title}</h3>
                            <p className="mt-2 text-sm text-text-muted leading-relaxed px-2">{step.description}</p>
                        </RevealItem>
                    ))}
                </RevealGroup>
            </div>
        </section>
    );
};

export default Process;
